/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppendCategoryToMenuModel as DigiworkMaitreDPosDtoMenuAppendCategoryToMenuModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Menu/append-category-to-menu-model';

export interface AddCategoryToMenu$Params {
      body?: DigiworkMaitreDPosDtoMenuAppendCategoryToMenuModel
}

export function addCategoryToMenu(http: HttpClient, rootUrl: string, params?: AddCategoryToMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addCategoryToMenu.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addCategoryToMenu.PATH = '/api/gmn/Menu/addcategorytomenu';
